export const getAuthFlags = (settings) => {
	const opts = settings?.authOptions || {};

	return {
		allowEmailPassword: opts.allowEmailPassword ?? true,
		allowGitLogin: opts.allowGitHubLogin ?? true,
		allowGoogleLogin: opts.allowGoogleLogin ?? true,
		allowLinkedInLogin: opts.allowLinkedInLogin ?? true,
	};
};